import {Component, Input, OnInit} from '@angular/core';
import * as searchActions from '@app/marketplace/products/state/product-search/search-actions';
import {ProductProviderEnum} from '@app/marketplace/core/enum/productProvider';
import {Store} from '@ngrx/store';
import {Router} from '@angular/router';

@Component({
  selector: 'app-shipping-amazon-section',
  templateUrl: './shipping-amazon-section.component.html',
  styleUrls: ['./shipping-amazon-section.component.css']
})
export class ShippingAmazonSectionComponent implements OnInit {

  @Input()
  provider: ProductProviderEnum;
  @Input() title: string;

  constructor(private store: Store<any>, private router: Router) { }

  ngOnInit(): void {
  }

  async getAmazonProducts(shipping: number) {

    if (this.provider == ProductProviderEnum.Amazon || this.provider == ProductProviderEnum.Shein || this.provider == ProductProviderEnum.Walmart || this.provider == ProductProviderEnum.HomeDepot) {
      this.store.dispatch(searchActions.SetProvider({provider: this.provider}));
      if (shipping == 1) {
        this.store.dispatch(searchActions.SearchProductsSuccess({term: 'refrigerador'}));
      } else {
        this.store.dispatch(searchActions.SearchProductsSuccess({term: 'televisores'}));
      }
      this.router.navigate(['market/productos-compras-cuba-online']);
    } else {
      this.router.navigate(['market/tienda-online-cuba/productos-envio-cuba']);
    }
  }
}
